import React, { useState } from 'react';
import { Modal, Button, Table, Form, Row, Col } from 'react-bootstrap';

interface modalProps {
    show: any;
    onHide: any;
}

interface Parcela {
    tipoCobranca: string;
    bandeira: string;
    autorizacao: string;
    vencimento: string;
    valor: string;
  }
  

const VencimentosModal: React.FC<modalProps> = ({ show, onHide }) => {
    const [formaPagamento, setFormaPagamento] = useState('A-VISTA');
    const [tipoCobranca, setTipoCobranca] = useState('DINHEIRO');
    const [bandeiraCartao, setBandeiraCartao] = useState('');
    const [numAutorizacao, setNumAutorizacao] = useState('');
    const [vencimento, setVencimento] = useState(new Date().toISOString().split('T')[0]);
    const [valor, setValor] = useState('');
    const [parcelas, setParcelas] = useState<Parcela[]>([]);

    const totalVenda = 2.00; // valor fixo de exemplo
    const totalParcelas = parcelas.reduce((sum, p) => sum + parseFloat(p.valor), 0);
    const troco = (totalParcelas - totalVenda).toFixed(2);

    const incluirParcela = () => {
        if (!valor) return;
        const novaParcela = {
            tipoCobranca,
            bandeira: bandeiraCartao || '(Nenhuma)',
            autorizacao: numAutorizacao || '-',
            vencimento,
            valor
        };
        setParcelas([...parcelas, novaParcela]);
        setValor('');
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
            <Modal.Header closeButton style={{ background: 'linear-gradient(#f8f9fa, #d6d8db)' }}>
                <Modal.Title>Vencimentos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Informações sobre os vencimentos</h6>
                <Row className="mb-2">
                    <Col md={4}>
                        <Form.Label>Forma de pagamento</Form.Label>
                        <Form.Select value={formaPagamento} onChange={(e) => setFormaPagamento(e.target.value)}>
                            <option>A-VISTA</option>
                            <option>A PRAZO</option>
                        </Form.Select>
                    </Col>
                    <Col md={2} className="d-flex align-items-end">
                        <Button variant="success" className="w-100">Calcular</Button>
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col md={3}>
                        <Form.Label>Tipo cobrança</Form.Label>
                        <Form.Select value={tipoCobranca} onChange={(e) => setTipoCobranca(e.target.value)}>
                            <option>DINHEIRO</option>
                            <option>CARTÃO</option>
                            <option>BOLETO</option>
                        </Form.Select>
                    </Col>
                    <Col md={3}>
                        <Form.Label>Bandeira do cartão</Form.Label>
                        <Form.Select value={bandeiraCartao} onChange={(e) => setBandeiraCartao(e.target.value)}>
                            <option>(Nenhuma)</option>
                            <option>Visa</option>
                            <option>Mastercard</option>
                        </Form.Select>
                    </Col>
                    <Col md={2}>
                        <Form.Label>Nº autorização</Form.Label>
                        <Form.Control
                            type="text"
                            value={numAutorizacao}
                            onChange={(e) => setNumAutorizacao(e.target.value)}
                        />
                    </Col>
                    <Col md={2}>
                        <Form.Label>Vencimento</Form.Label>
                        <Form.Control
                            type="date"
                            value={vencimento}
                            onChange={(e) => setVencimento(e.target.value)}
                        />
                    </Col>
                    <Col md={2}>
                        <Form.Label>Valor</Form.Label>
                        <Form.Control
                            type="text"
                            value={valor}
                            onChange={(e) => setValor(e.target.value)}
                        />
                    </Col>
                    <Col md={1} className="d-flex align-items-end">
                        <Button variant="primary" onClick={incluirParcela}>Incluir</Button>
                    </Col>
                </Row>

                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    <Table bordered hover size="sm">
                        <thead className="table-light">
                            <tr>
                                <th>Nº</th>
                                <th>TIPO COBRANÇA</th>
                                <th>BANDEIRA</th>
                                <th>Nº AUTORIZAÇÃO</th>
                                <th>VENCIMENTO</th>
                                <th>VALOR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {parcelas.length === 0 ? (
                                <tr>
                                    <td className="text-center">&lt; Nenhuma informação &gt;</td>
                                </tr>
                            ) : (
                                parcelas.map((parcela, idx) => (
                                    <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>{parcela.tipoCobranca}</td>
                                        <td>{parcela.bandeira}</td>
                                        <td>{parcela.autorizacao}</td>
                                        <td>{parcela.vencimento}</td>
                                        <td>{parseFloat(parcela.valor).toFixed(2)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>

                <Row className="mt-3">
                    <Col md={3}>
                        <Form.Check label="Quando o troco estiver negativo lançar como desconto" />
                        <Form.Check label="Gerar NFC-e após finalizado" />
                    </Col>
                    <Col md={{ span: 3, offset: 6 }}>
                        <Table bordered size="sm">
                            <tbody>
                                <tr>
                                    <td><strong>Total da venda</strong></td>
                                    <td className="text-end">{totalVenda.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Total das parcelas</strong></td>
                                    <td className="text-end">{totalParcelas.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Troco</strong></td>
                                    <td className="text-end">{troco}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" disabled>OK</Button>
                <Button variant="secondary" onClick={onHide}>Cancelar</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default VencimentosModal
